import type { KyInstance } from 'ky';

import { ensureError, formatString, isNotDefined } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Deletes a comment from a specific mailing.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingId - The unique identifier of the mailing from which the comment will be deleted.
 * @param commentId - The unique identifier of the comment to delete.
 * @returns A promise that resolves to an {@link OperationResult} indicating the outcome of the delete operation.
 * @throws Will throw an error if the HTTP request fails.
 */
export const deleteMailingComment = async (instance: KyInstance, mailingId?: number, commentId?: number) => {
  try {
    if (isNotDefined(mailingId) || isNotDefined(commentId)) {
      throw new Error('Mailing ID and Comment ID must be provided to delete a mailing comment.');
    }

    return await instance
      .delete<OperationResult>(
        formatString(Uri.mailing.deleteMailingComment, mailingId.toString(), commentId.toString())
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
